/** Normalise pour une recherche insensible à la casse et aux accents. */
export function normalizeSearchText(value: string): string {
  return value
    .normalize('NFD')
    .replace(/\p{M}/gu, '')
    .toLowerCase();
}

export function searchIncludes(haystack: string, needle: string): boolean {
  const q = needle.trim();
  if (!q) return true;
  return normalizeSearchText(haystack).includes(normalizeSearchText(q));
}
